import * as R from 'ramda'
import React, { useRef, useEffect, Suspense } from "react"
import { Stats } from "@react-three/drei"
import { useAnimationFrame } from "./util"

import useStore from "./AppStore"

import R3FCanvas from "./AppCanvas"
import Content from "./AppContent"

import LangSwitch from "./Html/LangSwitch"
import AudioViz from "./Html/AudioViz"
import Footer from "./Html/Footer"
import Intro from "./Html/Intro"
import Debug from "./Html/Debug"
import Lines from './Html/Lines'

const audioInstance = document.querySelector(".audio")

export default function App() {
  
  // scroll area height
  const SCROLLHEIGHT = 9000

  // stops for arrow navigation
  const stops = [
    0, 800,
    1500,1800, // 2
    2800,3100, // 3
    4000,4550, // 4
    6000,6750,7450, // 5
    8800
    // 9000,9550 // 6
  ]

  // initial
  const initial = useStore(s=>s.initial)

  // check if url has ?debug=1
  const isDebug = new URLSearchParams(window.location.search).get("debug") == 1

  // refs
  const scrollAreaRef = useRef(null)
  const contentRef = useRef(null)

  // onScroll
  const onScroll = e => useStore.getState().scrollTop.current = e.target.scrollTop
  useEffect(() => void onScroll({ target: scrollAreaRef.current }), [])

  // requestAnimationFrame 
  useAnimationFrame(deltaTime => {
    
    // update smooth scroll
    const top = useStore.getState().scrollTop.current/(SCROLLHEIGHT-window.innerHeight)*SCROLLHEIGHT
    useStore.getState().actions.changeTop(top)
    
    if(scrollAreaRef.current && contentRef.current){
      // initial scene
      scrollAreaRef.current.style.overflow = useStore.getState().initial ? 'hidden' : 'auto'
      // final scene
      scrollAreaRef.current.style.backgroundColor = useStore.getState().top >= 8400 ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0)'
      // contentRef.current.style.display = useStore.getState().top >= 8400 ? 'none' : 'block'
    }
    
  })

  // ARROW NAVIGATION
  // find closest stop
  function closestStop(){
    const current = useStore.getState().scrollTop.current/(SCROLLHEIGHT-window.innerHeight)*SCROLLHEIGHT
    const closest = R.reduce((acc,value)=>Math.abs(acc - current) < Math.abs(value - current) ? acc : value, 0, stops)
    return stops.indexOf(closest)
  }
  function scrollPrev() {
    const prev =  Math.max(closestStop()-1,0)
    console.log('prev slide', prev, stops[prev])
    scrollAreaRef.current.scrollTo(0,stops[prev]*(SCROLLHEIGHT-window.innerHeight)/SCROLLHEIGHT)
  }
  function scrollNext() {
    const closest = closestStop()
    const next = Math.min(stops.length-1, useStore.getState().top < stops[closest] -100 ? closest : closest + 1)
    console.log('next slide', next, stops[next])
    scrollAreaRef.current.scrollTo(0,stops[next]*(SCROLLHEIGHT-window.innerHeight)/SCROLLHEIGHT)
  }

  // AUDIO
  function audioHandle(){

    const audioPlay = useStore.getState().audioPlay
    useStore.setState({audioPlay: !audioPlay})
    
    if(audioPlay){
      audioInstance.pause()
    } else {
      audioInstance.play()
    }
  }
  function playAudio(){
    audioInstance.play()
    useStore.setState({audioPlay: true})
  }

  return (
    <>
      {/* CANVAS */}
      <Suspense fallback={null}>
        <R3FCanvas />
      </Suspense>
      {/* SCROLL AREA */}
      <div className="scrollArea" ref={scrollAreaRef} onScroll={onScroll}>
        <div style={{ height: `${SCROLLHEIGHT}px` }} />
      </div>
      {/* DOM */}
      <div className={`contentArea ${initial ? 'before' : 'after'}`} ref={contentRef}>
        <div className="box">
          <Lines />
          <Intro play={()=>playAudio()} />
          <Content />
          <Footer start={8400} end={8700} />
          <LangSwitch />
          <AudioViz onClick={()=>audioHandle()} />
        </div>
        <div className="arrow up" onClick={()=>scrollPrev()}>↑</div>
        <div className="arrow down" onClick={()=>scrollNext()}>↓</div>
      </div>
      {/* DEBUG */}
      {isDebug && <>
        <Stats showPanel={0} className="stats" />
        <Debug />
      </>}
    </>
  )
}